"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames = require("classnames");
var styles = require("spry-react/Grid/gridStyles");
var checkboxField_1 = require("spry-react/Checkbox/checkboxField");
var currency_1 = require("spry-react/Number/currency");
var link_1 = require("spry-react/Link/link");
var idGenerator_1 = require("spry-react/utils/idGenerator");
var buttonKeyPressHandler_1 = require("spry-react/utils/buttonKeyPressHandler");
var SortDirection;
(function (SortDirection) {
    SortDirection[SortDirection["None"] = 0] = "None";
    SortDirection[SortDirection["Ascending"] = 1] = "Ascending";
    SortDirection[SortDirection["Descending"] = 2] = "Descending";
})(SortDirection = exports.SortDirection || (exports.SortDirection = {}));
function GridCellSizer(props) {
    return React.createElement("div", { style: props.style, className: props.className }, props.children);
}
exports.GridCellSizer = GridCellSizer;
/* ********** Header Cells ********** */
var sortIndicators = [
    React.createElement("span", { className: 'sort-ind-asc', key: 'sort-ind-asc' }),
    React.createElement("span", { className: 'sort-ind-desc', key: 'sort-ind-desc' })
];
function HiddenHeader(props) {
    return null;
}
exports.HiddenHeader = HiddenHeader;
var GridContentHeader = /** @class */ (function (_super) {
    __extends(GridContentHeader, _super);
    function GridContentHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GridContentHeader.prototype.render = function () {
        var _a;
        var classes = classnames(this.props.className, (_a = {},
            _a[styles.columnHeaderCentered] = this.props.centerContent,
            _a[styles.columnHeaderRight] = this.props.isNumericColumn,
            _a));
        return (React.createElement("div", { style: this.props.style, className: classes, title: this.props.title, role: "columnheader" }, this.props.children));
    };
    return GridContentHeader;
}(React.PureComponent));
exports.GridContentHeader = GridContentHeader;
var GridSortHeaderContent = /** @class */ (function (_super) {
    __extends(GridSortHeaderContent, _super);
    function GridSortHeaderContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GridSortHeaderContent.prototype.render = function () {
        var _a, _b;
        var sortDirectionClass = getSortDirectionClass(this.props.sort.direction);
        var cssClasses = classnames('sort-header', sortDirectionClass, this.props.className);
        return (React.createElement("div", __assign({ className: cssClasses, style: this.props.style, role: "columnheader" }, sortableColumnHeaderProps((_a = this.props.sort) === null || _a === void 0 ? void 0 : _a.onSort, (_b = this.props.sort) === null || _b === void 0 ? void 0 : _b.direction)),
            React.createElement("div", { style: { display: "inline-block" } }, this.props.children),
            sortIndicators));
    };
    return GridSortHeaderContent;
}(React.PureComponent));
exports.GridSortHeaderContent = GridSortHeaderContent;
var GridSortIconHeaderContent = /** @class */ (function (_super) {
    __extends(GridSortIconHeaderContent, _super);
    function GridSortIconHeaderContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GridSortIconHeaderContent.prototype.render = function () {
        //sort-content css class has a padding.
        //It seems to be used when sorting the text columns in combination with css class non-sort-header
        //but for icons the css class grid-icon-cell has its own padding that overrides sort-contents when on the same element.
        //this split out sort-content into its own element and we have to now override its padding.
        var cssStyle = __assign(__assign({}, this.props.style), { padding: "0px" });
        return React.createElement(GridSortHeaderContent, __assign({}, this.props, { style: cssStyle }));
    };
    return GridSortIconHeaderContent;
}(React.PureComponent));
exports.GridSortIconHeaderContent = GridSortIconHeaderContent;
var TextHeader = /** @class */ (function (_super) {
    __extends(TextHeader, _super);
    function TextHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TextHeader.prototype.render = function () {
        var _a;
        var classes = classnames(styles.textColumnHeader, (_a = {},
            _a[styles.columnHeaderCentered] = this.props.centerContent,
            _a[styles.columnHeaderRight] = this.props.isNumericColumn,
            _a));
        return (React.createElement("div", { className: classes, role: "columnheader" },
            React.createElement("h4", { className: classnames('non-sort-header', { 'text-ellipsis': this.props.ellipsis }) }, this.props.label)));
    };
    return TextHeader;
}(React.PureComponent));
exports.TextHeader = TextHeader;
function getSortDirectionClass(direction) {
    switch (direction) {
        case SortDirection.None:
            return "";
        case SortDirection.Ascending:
            return "sort-asc";
        case SortDirection.Descending:
            return "sort-desc";
    }
}
function getSortDirectionAria(direction) {
    switch (direction) {
        case null:
        case undefined:
        case SortDirection.None:
            return "none";
        case SortDirection.Ascending:
            return "ascending";
        case SortDirection.Descending:
            return "descending";
    }
}
function SortHeading(props) {
    var _a, _b;
    var label = props.label, sort = props.sort;
    var sortClass = !!sort && getSortDirectionClass(sort.direction);
    var classes = classnames(sortClass, !!sort ? 'sort-header' : 'non-sort-header', { 'text-ellipsis': props.ellipsis });
    return React.createElement("h4", __assign({ className: classes }, sortableColumnHeaderProps((_a = sort) === null || _a === void 0 ? void 0 : _a.onSort, (_b = sort) === null || _b === void 0 ? void 0 : _b.direction)),
        label || '\u00A0',
        !!sort && sortIndicators);
}
var SortableTextHeader = /** @class */ (function (_super) {
    __extends(SortableTextHeader, _super);
    function SortableTextHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SortableTextHeader.prototype.render = function () {
        var _a;
        var sortDirectionClass = getSortDirectionClass(this.props.sort.direction);
        var classes = classnames(styles.textColumnHeader, sortDirectionClass, (_a = {},
            _a[styles.columnHeaderCentered] = this.props.centerContent,
            _a[styles.columnHeaderRight] = this.props.isNumericColumn,
            _a['text-ellipsis'] = this.props.ellipsis,
            _a));
        return (React.createElement("div", { className: classes, role: "columnheader" },
            React.createElement("h4", __assign({ className: "sort-header " + classes }, sortableColumnHeaderProps(this.props.sort.onSort, this.props.sort.direction)),
                this.props.label,
                sortIndicators)));
    };
    return SortableTextHeader;
}(React.PureComponent));
exports.SortableTextHeader = SortableTextHeader;
function sortableColumnHeaderProps(onSort, sortDirection) {
    return {
        onClick: (onSort !== null && onSort !== void 0 ? onSort : (function () { })),
        onKeyPress: buttonKeyPressHandler_1.buttonKeyPressHandler((onSort !== null && onSort !== void 0 ? onSort : (function () { }))),
        tabIndex: onSort ? 0 : undefined,
        'aria-sort': getSortDirectionAria(sortDirection)
    };
}
var StackedTextHeader = /** @class */ (function (_super) {
    __extends(StackedTextHeader, _super);
    function StackedTextHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StackedTextHeader.prototype.render = function () {
        var _a;
        var classes = classnames(styles.textColumnHeader, (_a = {},
            _a[styles.columnHeaderCentered] = this.props.centerContent,
            _a[styles.columnHeaderRight] = this.props.isNumericColumn,
            _a));
        return (React.createElement("div", { className: classes, role: "columnheader" },
            React.createElement("h4", { className: classnames('non-sort-header', { 'text-ellipsis': this.props.ellipsisLabel1 }) }, this.props.label1 || '\u00A0'),
            React.createElement("h4", { className: classnames('non-sort-header', { 'text-ellipsis': this.props.ellipsisLabel2 }) }, this.props.label2 || '\u00A0')));
    };
    return StackedTextHeader;
}(React.PureComponent));
exports.StackedTextHeader = StackedTextHeader;
var SortableStackedTextHeader = /** @class */ (function (_super) {
    __extends(SortableStackedTextHeader, _super);
    function SortableStackedTextHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SortableStackedTextHeader.prototype.render = function () {
        var _a;
        var _b = this.props, label1 = _b.label1, label2 = _b.label2, sortTop = _b.sortTop, sortBottom = _b.sortBottom, centerContent = _b.centerContent, isNumericColumn = _b.isNumericColumn;
        var classes = classnames(styles.textColumnHeader, (_a = {},
            _a[styles.columnHeaderCentered] = centerContent,
            _a[styles.columnHeaderRight] = isNumericColumn,
            _a));
        return (React.createElement("div", { className: classes, role: "columnheader" },
            React.createElement(SortHeading, { ellipsis: this.props.ellipsisLabel1, label: label1, sort: sortTop }),
            React.createElement(SortHeading, { ellipsis: this.props.ellipsisLabel2, label: label2, sort: sortBottom })));
    };
    return SortableStackedTextHeader;
}(React.PureComponent));
exports.SortableStackedTextHeader = SortableStackedTextHeader;
var SplitSortableStackedTextHeaderTop = /** @class */ (function (_super) {
    __extends(SplitSortableStackedTextHeaderTop, _super);
    function SplitSortableStackedTextHeaderTop() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SplitSortableStackedTextHeaderTop.prototype.render = function () {
        var _a;
        var _b = this.props, label1a = _b.label1a, label1b = _b.label1b, label2 = _b.label2, sortTopLeft = _b.sortTopLeft, sortTopRight = _b.sortTopRight, sortBottom = _b.sortBottom, centerContent = _b.centerContent, isNumericColumn = _b.isNumericColumn;
        var classes = classnames(styles.textColumnHeader, (_a = {},
            _a[styles.columnHeaderCentered] = centerContent,
            _a[styles.columnHeaderRight] = isNumericColumn,
            _a));
        var sortClass1a = getSortDirectionClass(sortTopLeft.direction);
        var classes1a = ("sort-header sort-header-inline " + sortClass1a).trim();
        var sortClass1b = getSortDirectionClass(sortTopRight.direction);
        var classes1b = ("sort-header sort-header-inline " + sortClass1b).trim();
        return (React.createElement("div", { className: classes, role: "columnheader" },
            React.createElement("h4", __assign({ className: classes1a }, sortableColumnHeaderProps(sortTopLeft.onSort, sortTopLeft.direction)),
                label1a,
                sortIndicators),
            React.createElement("h4", __assign({ className: classes1b, style: { paddingLeft: '0' } }, sortableColumnHeaderProps(sortTopRight.onSort, sortTopRight.direction)),
                label1b,
                sortIndicators),
            React.createElement(SortHeading, { label: label2, sort: sortBottom })));
    };
    return SplitSortableStackedTextHeaderTop;
}(React.PureComponent));
exports.SplitSortableStackedTextHeaderTop = SplitSortableStackedTextHeaderTop;
var SplitSortableStackedTextHeaderBottom = /** @class */ (function (_super) {
    __extends(SplitSortableStackedTextHeaderBottom, _super);
    function SplitSortableStackedTextHeaderBottom() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SplitSortableStackedTextHeaderBottom.prototype.render = function () {
        var _a;
        var _b = this.props, label1 = _b.label1, label2a = _b.label2a, label2b = _b.label2b, sortTop = _b.sortTop, sortBottomLeft = _b.sortBottomLeft, sortBottomRight = _b.sortBottomRight, centerContent = _b.centerContent, isNumericColumn = _b.isNumericColumn;
        var classes = classnames(styles.textColumnHeader, (_a = {},
            _a[styles.columnHeaderCentered] = centerContent,
            _a[styles.columnHeaderRight] = isNumericColumn,
            _a));
        var sortClass2a = getSortDirectionClass(sortBottomLeft.direction);
        var classes2a = ("sort-header sort-header-inline " + sortClass2a).trim();
        var sortClass2b = getSortDirectionClass(sortBottomRight.direction);
        var classes2b = ("sort-header sort-header-inline " + sortClass2b).trim();
        return (React.createElement("div", { className: classes, role: "columnheader" },
            React.createElement(SortHeading, { label: label1, sort: sortTop }),
            React.createElement("h4", __assign({ className: classes2a }, sortableColumnHeaderProps(sortBottomLeft.onSort, sortBottomLeft.direction)),
                label2a,
                sortIndicators),
            React.createElement("h4", __assign({ className: classes2b, style: { paddingLeft: '0' } }, sortableColumnHeaderProps(sortBottomRight.onSort, sortBottomRight.direction)),
                label2b,
                sortIndicators)));
    };
    return SplitSortableStackedTextHeaderBottom;
}(React.PureComponent));
exports.SplitSortableStackedTextHeaderBottom = SplitSortableStackedTextHeaderBottom;
var IconHeader = /** @class */ (function (_super) {
    __extends(IconHeader, _super);
    function IconHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconHeader.prototype.render = function () {
        var props = this.props;
        if (!props.iconClass) {
            return (React.createElement("div", { style: { padding: '0.5em' }, role: "columnheader" },
                React.createElement("span", { className: styles.iconColumnHeader }, "\u00A0")));
        }
        else if (props.onClick) {
            var iconClasses = classnames(props.iconClass, 'no-padding-psuedo-elements', {
                'disabled': props.disabled
            });
            return (React.createElement("div", { className: styles.gridIconCell, role: "columnheader" },
                React.createElement(link_1.Link, { className: iconClasses, onClick: props.onClick, disabled: props.disabled, title: props.title }, props.overlapIconClass
                    ? React.createElement("span", { className: props.overlapIconClass })
                    : null)));
        }
        else {
            return (React.createElement("div", { className: classnames(styles.gridIconCell, props.iconClass, 'no-padding-psuedo-elements'), title: props.title, role: "columnheader" }, props.overlapIconClass
                ? React.createElement("span", { className: props.overlapIconClass })
                : null));
        }
    };
    return IconHeader;
}(React.PureComponent));
exports.IconHeader = IconHeader;
var SortableIconHeader = /** @class */ (function (_super) {
    __extends(SortableIconHeader, _super);
    function SortableIconHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SortableIconHeader.prototype.render = function () {
        var sortDirectionClass = getSortDirectionClass(this.props.sort.direction);
        var props = this.props;
        return (React.createElement("div", __assign({ className: classnames(styles.gridIconCell, props.iconClass, sortDirectionClass, 'no-padding-psuedo-elements', 'sort-header'), title: props.title, role: "columnheader" }, sortableColumnHeaderProps(props.sort.onSort, props.sort.direction)), sortIndicators));
    };
    return SortableIconHeader;
}(React.PureComponent));
exports.SortableIconHeader = SortableIconHeader;
var CheckboxHeader = /** @class */ (function (_super) {
    __extends(CheckboxHeader, _super);
    function CheckboxHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckboxHeader.prototype.render = function () {
        return (React.createElement("div", { className: styles.gridCheckboxCell, role: "columnheader" },
            React.createElement(checkboxField_1.CheckboxField, { value: this.props.isChecked, onToggle: this.props.toggleSelections, title: this.props.title })));
    };
    return CheckboxHeader;
}(React.PureComponent));
exports.CheckboxHeader = CheckboxHeader;
function getVerticalCellAlignmentStyle(verticalAlignment) {
    if (verticalAlignment == "top") {
        return { alignSelf: "flex-start" };
    }
    else if (verticalAlignment == "bottom") {
        return { alignSelf: "flex-end" };
    }
    else {
        throw "Unrecognized Vertical Alignment";
    }
}
exports.getVerticalCellAlignmentStyle = getVerticalCellAlignmentStyle;
var ContentCell = /** @class */ (function (_super) {
    __extends(ContentCell, _super);
    function ContentCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ContentCell.prototype.render = function () {
        var classes = classnames(styles.gridCell, 'text-ellipsis');
        return React.createElement("div", { className: classes, role: "cell" }, this.props.children);
    };
    return ContentCell;
}(React.Component));
exports.ContentCell = ContentCell;
var MenuCell = /** @class */ (function (_super) {
    __extends(MenuCell, _super);
    function MenuCell(props) {
        var _this = _super.call(this, props) || this;
        _this.buttonId = "gridContextMenuButton" + idGenerator_1.GenerateId();
        return _this;
    }
    MenuCell.prototype.render = function () {
        return (React.createElement("div", { className: styles.menuCell, role: "cell" },
            React.createElement("div", { className: styles.menuCellContent }, this.props.contentCell),
            React.createElement("div", { className: styles.menuCellMenu },
                React.createElement("button", { id: this.buttonId, className: 'vertical-ellipsis-icon', onClick: this.props.menuButtonClickHandler }))));
    };
    return MenuCell;
}(React.PureComponent));
exports.MenuCell = MenuCell;
function TextCell(props) {
    var _a;
    var classes = classnames(styles.gridCell, 'text-ellipsis', props.className, (_a = {},
        _a[styles.numeric] = props.isNumericColumn,
        _a));
    return (React.createElement("div", { className: classes, role: "cell" },
        React.createElement("p", { className: 'text-ellipsis' }, props.value)));
}
exports.TextCell = TextCell;
function StackedTextCell(props) {
    return (React.createElement(StackedContentCell, { top: props.value1, bottom: props.value2, additionalCellClasses: 'text-ellipsis', centerContent: props.centerContent, verticalAlignment: props.verticalAlignment }));
}
exports.StackedTextCell = StackedTextCell;
function StackedContentCell(props) {
    var cellClasses = "" + styles.gridCell + (props.additionalCellClasses ? " " + props.additionalCellClasses : '');
    var renderEmptyElements = props.renderEmptyElements === undefined ? true : props.renderEmptyElements;
    var top = renderEmptyElements && (!props.top || typeof props.top === "string")
        ? React.createElement("p", { className: 'text-ellipsis' }, props.top || '\u00A0')
        : props.top;
    var bottom = renderEmptyElements && (!props.bottom || typeof props.bottom === "string")
        ? React.createElement("p", { className: 'text-ellipsis' }, props.bottom || '\u00A0')
        : props.bottom;
    return (React.createElement("div", { className: cellClasses, role: "cell" },
        top,
        bottom));
}
exports.StackedContentCell = StackedContentCell;
function LinkCell(props) {
    var link = React.createElement(link_1.Link, __assign({ className: 'text-ellipsis' }, props.linkProps), props.linkText);
    return (React.createElement("div", { className: styles.gridCell + " text-ellipsis", role: "cell" }, props.isPrimaryAction
        ? React.createElement("h4", null, link)
        : link));
}
exports.LinkCell = LinkCell;
function StackedLinkCell(props) {
    var topElementContent = props.textValueTop
        ? props.linkPropsTop
            ? React.createElement(link_1.Link, __assign({}, props.linkPropsTop, { className: 'text-ellipsis' }), props.textValueTop)
            : React.createElement("p", { className: 'text-ellipsis' }, props.textValueTop)
        : '\u00A0';
    var topElement = props.isPrimaryAction ? React.createElement("h4", null, topElementContent) : topElementContent;
    var bottomElement = props.textValueBottom
        ? props.linkPropsBottom
            ? React.createElement(link_1.Link, __assign({}, props.linkPropsBottom, { className: 'text-ellipsis' }), props.textValueBottom)
            : React.createElement("p", { className: 'text-ellipsis' }, props.textValueBottom)
        : '\u00A0';
    return (React.createElement(StackedContentCell, { top: topElement, bottom: bottomElement, additionalCellClasses: 'text-ellipsis' }));
}
exports.StackedLinkCell = StackedLinkCell;
function CurrencyCell(props) {
    var currencyValue = props.currencyValue, userClasses = props.className, domPropsRest = __rest(props, ["currencyValue", "className"]);
    var currencyFragment = currency_1.getCurrencyFragment(currencyValue);
    var classes = classnames(styles.gridCell, styles.numeric, userClasses);
    return (React.createElement("div", __assign({ className: classes }, domPropsRest, { role: "cell" }), currencyFragment));
}
exports.CurrencyCell = CurrencyCell;
function CurrencyLinkCell(props) {
    var currencyValue = props.currencyValue, userClasses = props.className, onLinkClick = props.onLinkClick, domPropsRest = __rest(props, ["currencyValue", "className", "onLinkClick"]);
    var classes = classnames(styles.gridCell, styles.numeric, userClasses);
    return (React.createElement("div", __assign({ className: classes }, domPropsRest, { role: "cell" }),
        React.createElement(link_1.Link, { onClick: onLinkClick, disabled: props.disabled }, currency_1.getCurrencyFragment(currencyValue))));
}
exports.CurrencyLinkCell = CurrencyLinkCell;
var IconCell = /** @class */ (function (_super) {
    __extends(IconCell, _super);
    function IconCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconCell.prototype.render = function () {
        var props = this.props;
        if (props.onClick) {
            var iconClasses = classnames(props.iconClass, 'no-padding-psuedo-elements', {
                'disabled': props.disabled
            });
            return (React.createElement("div", { className: styles.gridIconCell, role: "cell" },
                React.createElement(link_1.Link, { className: iconClasses, onClick: props.onClick, style: props.style, disabled: props.disabled, title: props.title }, props.overlapIconClass
                    ? React.createElement("span", { className: props.overlapIconClass })
                    : null)));
        }
        else {
            //The icon/title doesn't report for a screenreader
            return (React.createElement("div", { className: classnames(styles.gridIconCell, props.iconClass, 'no-padding-psuedo-elements'), title: props.title, style: props.style, role: "cell" }, props.overlapIconClass
                ? React.createElement("span", { className: props.overlapIconClass })
                : null));
        }
    };
    IconCell.defaultProps = {
        centerContent: true
    };
    return IconCell;
}(React.Component));
exports.IconCell = IconCell;
function CheckboxCell(props) {
    return (React.createElement("div", { className: styles.gridCheckboxCell, role: "cell" },
        React.createElement(checkboxField_1.CheckboxField, { value: props.isSelected, disabled: props.disabled, onToggle: props.onToggle, className: props.className, title: props.title })));
}
exports.CheckboxCell = CheckboxCell;
function Cell(props) {
    var userClasses = props.className, domPropsRest = __rest(props, ["className"]);
    var classes = classnames(styles.gridCell, userClasses);
    return React.createElement("div", __assign({ className: classes }, domPropsRest, { role: "cell" }), props.children);
}
exports.Cell = Cell;
function PlusNItems(props) {
    return (React.createElement("div", { style: { display: 'flex' }, role: "cell" },
        React.createElement("p", { className: 'text-ellipsis', style: { display: 'inline-block' } }, props.displayValue || '\u00A0'),
        props.totalItemCount > 1
            ? props.popperElement
            : null));
}
exports.PlusNItems = PlusNItems;
